import { List } from 'immutable';
import _ from 'lodash';

import OrderTicket from '../records/order/Ticket';

/**
 * Folds similar tickets into each other to reduce repetition
 * e.g. Two "1 Adult with 16-25" tickets would become "2 Adults with 16-25"
 *
 * @return {Immutable.List}
 */
export function getFoldedTickets (tickets, callback = _.identity) {
    return tickets
        .groupBy(callback)
        .reduce((newTickets, groupedTickets) => {
            const reducedTicket = groupedTickets.shift().reduce((newTicket, currentTicket) => {
                return newTicket.withMutations((ticket) => {
                    const addProps = (key) => newTicket.get(key) ?
                        newTicket.get(key) + currentTicket.get(key) :
                        newTicket.get(key);
                    if (ticket instanceof OrderTicket) {
                        return ticket
                            .set('adults', addProps('adults'))
                            .set('children', addProps('children'))
                            .set('price', addProps('price'));
                    }
                    return ticket
                        .set('adults', addProps('adults'))
                        .set('children', addProps('children'))
                        .set('price', addProps('price'))
                        .set('railcardDiscount', addProps('railcardDiscount'));
                });
            }, groupedTickets.first());
            return newTickets.push(reducedTicket);
        }, new List());
}



// WEBPACK FOOTER //
// ./src/helpers/Fares.js